/**
 * Eigen Indeling Widget (Epic C-5 — Mijn indeling & navigatie, Story C-5.1, UX-C6)
 *
 * Vult het gereserveerde v2-haakje uit verlof-spec V7 ("eigen Indelingen")
 * in: een compacte "Vandaag"-strook naast `EigenVerlofWidget`/
 * `EigenRoosterWidget` op het medewerker-dashboard. Hergebruikt
 * `useMyPlanning` (Story C-5.1) — geen tweede fetch/implementatie van
 * dezelfde `/me`-data (AD-9).
 */

import { Link } from 'react-router-dom';
import { useMyPlanning } from '../planning/hooks/useMyPlanning';
import { toDateString } from '../werkrooster/utils/dateUtils';

export function EigenIndelingWidget() {
  const today = toDateString(new Date());
  const { data, isLoading, isError } = useMyPlanning(today, today);
  const todayEntry = data?.days[0];

  const ochtend = todayEntry?.morning.assignment?.taskName ?? null;
  const middag = todayEntry?.afternoon.assignment?.taskName ?? null;

  const parts: string[] = [];
  if (ochtend) parts.push(`${ochtend} (ochtend)`);
  if (middag) parts.push(`${middag} (middag)`);
  const vandaagText = parts.length > 0 ? `Vandaag: ${parts.join(' · ')}` : 'Vandaag: geen indeling';

  return (
    <div data-testid="eigen-indeling-widget" className="bg-white rounded-lg border border-[#E2E8F0] shadow-sm">
      <div className="px-6 py-4 border-b border-[#E2E8F0] flex items-center justify-between">
        <h3 className="text-lg font-medium text-[#1E293B]">Mijn indeling</h3>
        <Link to="/mijn-indeling" className="text-sm text-[#54949E] hover:underline">
          Bekijk alle →
        </Link>
      </div>

      <div className="p-6">
        {isLoading ? (
          <div className="flex items-center justify-center py-8">
            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-[#2F5A7A]"></div>
          </div>
        ) : isError ? (
          <p data-testid="eigen-indeling-error" className="text-sm text-[#D64545]">
            Kon je indeling niet laden. Probeer het later opnieuw.
          </p>
        ) : (
          <p className="text-sm text-[#1E293B]">{vandaagText}</p>
        )}
      </div>
    </div>
  );
}
